import React, { FunctionComponent, useMemo } from "react";
import TraitSalesContext, {
  TraitSalesContextValue,
} from "contexts/TraitSalesContext";
import useFetchTraitSales from "hooks/useFetchTraitSales";
import { Center } from "@chakra-ui/react";
import BoldSpinner from "components/BoldSpinner";
import useConnectedAccount from "hooks/useConnectedAccount";
import useCurrency from "hooks/useCurrency";

type TraitSalesProviderProps = {};

const TraitSalesProvider: FunctionComponent<TraitSalesProviderProps> = ({
  children,
}) => {
  const [address] = useConnectedAccount();
  const currency = useCurrency();

  const data = useMemo(
    () => ({
      address,
      currency,
    }),
    [address, currency]
  );

  const [traitSales, fetch, isLoading] = useFetchTraitSales(data);

  const traitSalesByTokenId = useMemo(
    () =>
      traitSales?.reduce(
        (prev, sale) => ({
          ...prev,
          [sale.tokenId]: sale,
        }),
        {}
      ),
    [traitSales]
  );

  const contextValue = useMemo<TraitSalesContextValue>(
    () => ({
      traitSales: traitSales || [],
      traitSalesByTokenId: traitSalesByTokenId || {},
      fetchTraitSales: () => {
        fetch(data);
      },
      isLoading,
    }),
    [traitSales, traitSalesByTokenId, fetch, data, isLoading]
  );

  return (
    <TraitSalesContext.Provider value={contextValue}>
      {!traitSales ? (
        <Center h="100vh">
          <BoldSpinner size="xl" />
        </Center>
      ) : (
        children
      )}
    </TraitSalesContext.Provider>
  );
};

export default TraitSalesProvider;
